module.exports = __webpack_public_path__ + "img/feedback-form-header-image.4b827a9f.png";